import styled from 'styled-components'
import { flex, sizing } from 'styles'

export const Canvas = styled.div`
  ${flex}
  ${sizing}
  overflow: auto;
`
